module.exports = {
  add_more: 'Add more',
  provideFullAddress: 'Please provide your full address',
  dropdownBoth: 'Please fill out all fields',
  dropdownDay: 'Choose your preferred date',
  dropdownTime: 'Choose your preferred time',
  pictureDescription: 'Add a caption (optional)',
  changeEmail: 'Yes, change it',
  dontChangeEmail: 'No, keep it',
  yes: 'Yes',
  no: 'No',
  'next-step': 'Next',
  'next-step-wizard': 'Next',
  step: 'Step',
  off: 'Off',
  'first-step-wizard': "Yes, let's start",
  'last-step': 'Get offers',
  'go-back': 'Previous',
  'go-back-wizard': 'Previous step',
  understood: 'Great, I understand!',
  'company-placeholder': 'Company Inc. ',
  'company-autocomplete-label': '',
  'company-label': 'Company',
  'address-placeholder': '1, The Avenue',
  address_no_number_placeholder: 'Street address',
  'address-label': 'Address',
  'address-street-number-label': 'St. No.',
  'address-street-number-placeholder': '1A',
  'address-no-street-number-label': "The address doesn't have a number",
  'address-not-found': "Can't find address",
  'address-no-match': 'No results',
  'address-choose-from': 'Choose among several addresses',
  'address-invalid': 'The address is invalid',
  'address-missing': 'The address is missing',
  'address-missing-street-number': 'The street number is missing',
  address_alert: 'Did you write the correct address?',
  address_not_verified:
    "We're having trouble finding your address, but if you know this is correct you can continue by entering a valid postcode below.",
  postcode_needed: 'Enter a valid postcode to continue.',
  address_missing_city: 'The city is missing',
  'phone-invalid-length': '',
  'zip-error': 'Please add your Eircode',
  'zip-label': 'Eircode',
  'zip-does-not-exist': "The Eircode doesn't exist",
  'zip-warning': 'Are you sure you provided the correct Eircode?',
  zip_placeholder: 'XXX XXXX',
  'name-label': 'Your name',
  'date-format': 'DD/MM/YY',
  'date-label': 'Date (6 digits)',
  'birthdate-label': 'Date of birth (6 digits)',
  'national-identity-label': 'Your national identification number',
  'national-identity-placeholder': '',
  'national-identity-invalid': 'The national identification number is invalid',
  'national-identity-identical':
    "The co-borrower's national identification number can't be identical to that of the prinicipal applicant's",
  'bank-account-label': 'Your bank account number',
  'measuring-id-invalid': 'The Meter Point Reference Number is invalid',
  'bank-account-placeholder': '8 digits',
  'bank-account-invalid': 'The bank account number is invalid',
  'organization-identity-label': 'Company number',
  'organization-identity-placeholder': '6 digits',
  'organization-identity-invalid': 'The company number is invalid',
  'date-invalid': 'The date is invalid',
  'name-placeholder': 'First Name Surname',
  'name-invalid': 'The name is invalid',
  'email-alert-message': 'Did you write the correct email?',
  'email-label': 'Email',
  'email-placeholder': 'name@domain.co.uk',
  'email-does-not-exist': "This email doesn't exist",
  'email-invalid': 'This email is invalid',
  email_did_you_mean: 'Did you mean',
  'fetching-information': 'Fetching information',
  'comment-label': 'Additional information',
  'comment-placeholder': 'Optional, e.g. state specific needs or other relevant info here. ',
  'phone-alert-message': 'Did you write the correct phone number?',
  'phone-label': 'Phone',
  'phone-invalid': 'The phone number is invalid',
  'phone-must-begin-with-+': 'Phone number must begin with + ',
  'phone-foreign': 'Foreign phone number',
  'phone-placeholder': '07740 123456',
  'phone-foreign-placeholder-prefix': '353',
  'error-x-numbers': 'Must contain --x-- digits',
  'error-x-letters': 'Must contain --x-- letters',
  'error-min-rooms': 'You must choose at least one room',
  'error-min-x-letters': 'Must contain at least --x-- letters',
  'error-min-x-numbers': 'Must contain at least --x-- digits',
  'error-max-x-numbers': 'Must contain maximum --x-- digits',
  'error-inbetween-numbers': 'Must contain --x------y digits',
  'error-must-consist-of-x-letters': 'Must contain at least --x-- letters',
  'error-mandatory': 'This is mandatory',
  'error-choose': 'Choose at least --x-- option(s)',
  'error-min-age': 'Unfortunately, offers are only available to customers older than --x-- years',
  'error-must-accept': 'Must accept',
  'error-only-digits': 'Only digits',
  privacy:
    '<strong>Your privacy is protected:</strong> All form data is encrypted over a secure connection and we handle your details according to the UK GDPR.',
  'privacy-policy':
    '<h4>Privacy policy</h4><p><p>Privacy is essential to us at --x--. As a user, you can be confident that we will not use the information you provide for anything other than what you have given consent to and that we will store it securely.</p> <p>The data you hand in is the minimum suppliers require to be able to provide you with specific offers based on your needs. It will not be used for anything other than to provide you with offers within a reasonable time, based on your choices and preferences for communication and the administrative work related to this.</p><p>Your data is processed by the Norwegian IT company Nettbureau AS, which owns and operates --x--, and by the relevant suppliers.</p><p>Personal information about you shall only be processed for lawful purposes and will be deleted or anonymised when we no longer have grounds to process them.</p><p>Nettbureau must ensure that personal data about you is satisfactorily protected.</p><p>Nettbureau ensures communication with users using encryption.</p><p>Read more in our <a href="--y--" target="__blank">privacy policy</a>.</p>',
  close: 'Close',
  error_radio_button: 'Please choose a field',
  invalid_day: 'The date is invalid',
  invalid_day_in_month: "This date doesn't exist this month",
  invalid_month: 'The month is invalid',
  invalid_year: 'The year is invalid',
  invalid_country: 'The country is invalid',
  label_birthdate: 'Date of birth',
  label_date: 'Date',
  label_day: 'Day',
  label_month: 'Month',
  label_year: 'Year',
  locale: '',
  new_locale: '',
  missing_date: 'The date is missing',
  missing_month: 'The month is missing',
  missing_year: 'The year is missing',
  'datepicker-button': 'Choose date',
  email_wrong_user_account: 'Are you sure the email user account is correct?',
  email_wrong_email_address: 'Are you sure you have entered a valid email address?',
  not_valid_municipality: "The municipiality isn't valid",
  not_valid_state: "The state isn't valid",
  'invalid-file-size': 'The maximum file size is',
  'invalid-file-type': 'Invalid file type, valid file types are',
  'drop-files-first': 'Drop your files here or',
  'drop-files-last': 'click here to capture an image',
  'vehicle-label': 'Registration number',
  'vehicle-invalid': "The registration number isn't correct",
  'leazard-error-boundary-headline': "We're sorry, something went wrong",
  'leazard-error-boundary-description':
    'Please press the button below to try again. If the problem remains unsolved:',
  'leazard-error-boundary-contact-customer-service': 'Contact customer service',
  'leazard-error-boundary-email-subject': 'Form error',
  'leazard-error-boundary-button-text': 'Please try again',
  'sms-verification-label': 'Verify your phone number',
  'sms-verification-tinyLabel':
    'We’ve sent you a text message from "+47 59 44 45 00" with a verification code to confirm that --xx-- belongs to you. This ensures we can process your request quickly and correctly.',
  'sms-verification-error-message': 'Wrong code',
  'sms-verification-code-not-received-first': "Haven't received a code? ",
  'sms-verification-code-not-received-link': 'Click here',
  'sms-verification-code-not-received-last': ' to send it again.',
  'sms-verification-code-is-sent-again': "We've resent the code.",
  'sms-verification-code-retry-error': 'Please wait 30 seconds before trying again.',
  'eircode-invalid': 'This eircode is invalid',
  'leazard-two-factor-header': 'Nearly there',
  'leazard-two-factor-help-text':
    "We’ve sent you a text message with a verification code to confirm that this number belongs to you. You won't receive any more messages from +47 59 44 45 00.",
  'leazard-two-factor-submit': 'Complete',
  'leazard-two-factor-label': 'Write in the code',
  'leazard-loading-text': 'Processing your data',
  'accept-terms-of-use':
    'I accept the --x-- and confirm that the personal information is accurate.',
  'recaptcha-disclaimer': 'This site is protected by reCAPTCHA.',
};
